const local = {
  ga_analytics: ' ',
  url: {
    api: "https://api.labs.wmotorchile.cl"
  }
};

const dev = {
  ga_analytics: 'G-1YV6XCF56R',
  url: {
    api: "https://api.labs.wmotorchile.cl"
  }
};

const prod = {
  ga_analytics: 'G-1YV6XCF56R',
  url: {
    api: "https://api.wmotorchile.cl"
  }
};

const config = process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.trim() === 'production'
  ? prod
  : process.env.REACT_APP_ENV === 'development'
  ? dev
  : local;

export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};
